export class LoadParams {
    public busy: boolean = false;
    public finished: boolean = false;
    public to_load: number = 3;
}
